import './styles/main.scss';
import {BrowserRouter, Route, Routes, useSearchParams} from 'react-router-dom';
import {useMemo} from "react";
import InstallPage from "./pages/InstallPage";

function App() {

    return (
        <BrowserRouter>
            <Routes>
                <Route exact path="/install" element={<InstallPage/>} />
            </Routes>
        </BrowserRouter>
    )

}

export default App;
